module.exports = "<svg viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M2 16h16v1H2v-1zm15-2H3V6h14v8zm-1-7H4v6h12V7zM2 3h16v1H2V3z\"/></svg>"


//////////////////
// WEBPACK FOOTER
// ../ckeditor5-core/theme/icons/object-full-width.svg
// module id = 36
// module chunks = 0